import { useEffect, useState } from "react";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _BusinessProcess, _EmployeeContract, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../../../theme/Component/usePaginator";
import { toast } from "react-toastify";
import { BasicTable, MASK_DATE, MASK_NUMBER, MASK_TEXT_NOWRAP } from "../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { DropDown } from "../../../../theme/Component/DropDown";
import useModal, { MODAL_md, MODAL_SM, MODAL_XL } from "../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../theme/Component/Modal";
import { ExportXLSL } from "../../../../theme/Component/ExportXLSX";
import { TeamGroupMembersInfo } from "./TeamGroupMembersInfo/TeamGroupMembersInfo";
import { SelectIDFunctionalSingleton } from "../../../select/SelectIDFunctionalSingleton";

type formTeamGroupMembers = {
    FunctionalArea: Record<string, any>;
}

export const TeamGroupMembers = () => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_EmployeeContract)
    const _busProcess = useDataBean(_BusinessProcess);
    const paginador = usePaginator();

    const [form, setForm] = useState<Partial<formTeamGroupMembers>>({});
    const [listaReport, setListaReport] = useState<any[]>([]);

    const modalInfo = useModal(`Informacion de ${bean.AccountName}`, MODAL_XL);
    const modalExportList = useModal("Exportar Historial", MODAL_SM);
    const modalRequest = useModal("Iniciar Solicitud", MODAL_md);

    useEffect(() => {
        if (form.FunctionalArea?.IDLn) {
            getLista();
        }
    }, [paginador.page, form.FunctionalArea?.IDLn])

    const getLista = () => {
        instance.getEmployeeContracts(_single.getCurrenYear(), _single.getCurrentMonth(), null, null, form.FunctionalArea?.IDLn, null, null, 2, null, null, paginador.page, 15).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                setLista(resp.List)
            }
        ).catch(err => {
            toast.error(err)
        })
    }

    const getListaReport = () => {
        instance.getEmployeeContracts(_single.getCurrenYear(), _single.getCurrentMonth(), null, null, form.FunctionalArea?.IDLn, null, null, 2, null, null, paginador.page, 15).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                setListaReport(resp.List);
                modalExportList.open();
            }
        ).catch(err => {
            toast.error(err)
        })
    }

    const head = [
        { title: 'IDContrato', property: 'IDContract', visible: false, mask: MASK_NUMBER },
        { title: 'Usuario', property: 'AccountName', visible: true, mask: MASK_TEXT_NOWRAP },
        { title: 'Fecha de Nacimiento', property: 'BornDate', mask: MASK_DATE, visible: true },
        { title: 'Dirección', property: 'Address', mask: MASK_TEXT_NOWRAP, visible: false },
        { title: 'Teléfono', property: 'Tel', visible: true },
        { title: 'Correo Electrónico', property: 'eMail', visible: true },
        { title: 'Género', property: 'GenType', visible: true },
        { title: 'Plaza Laboral', property: 'IDLnFunctionalArea', mask: MASK_NUMBER, visible: true },
        { title: 'Fecha de Inicio', property: 'InitContract', mask: MASK_DATE, visible: false },
        { title: 'Ingreso Nación', property: 'NationInit', mask: MASK_DATE, visible: false },
        { title: 'Actualizado por', property: 'LastUpdateEmployeeName', visible: false },
        { title: 'Última Actualización', property: 'LastUpdate', visible: true, mask: MASK_DATE },
        { title: 'Estado', property: 'ContractStateName', visible: true },
    ]


    const iconButtonsItem = [
        { nombre: 'Iniciar Solicitud', icono: 'ri-file-add-line', visible: form.FunctionalArea?.IDLn, evento: () => { modalRequest.open() } },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Información del Empleado', icono: 'ri-file-user-line', visible: form.FunctionalArea?.IDBoss === _single.getAccountID(), evento: () => { modalInfo.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [obs, setObs] = useState<string | undefined>('');
    const [isValid, setIsValid] = useState<boolean>(false);

    const handleModalSubmit = () => {
        if (obs.trim().length < 15) {
            toast.error("La observación es obligatoria y debe tener al menos 15 caracteres.");
            setIsValid(true)
            return;
        }

        setIsValid(false);

        const initProps = { ...form.FunctionalArea };

        _busProcess.instance.requestBusinessProcess(_single.getAccountID(), obs, "SOLPERMISO", "GroupMember", form.FunctionalArea?.IDWorkGroupMember, JSON.stringify(initProps), "").then(
            (resp) => {
                toast.success(`Se ha Generado el Proceso ${resp.AlphaCode}`, { autoClose: false });
                modalRequest.close()
            }
        ).catch(err => console.log(err));
    };

    const actionsDropDown = [
        { id: 1, name: 'Exportar', permiso: null, activo: true },

    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={buttonEvent}></DropDown>
                </div>
            </div>
        )
    }
    const buttonEvent = (e) => {
        if (e.id === 1) {
            getListaReport();
        }

    }

    return (
        <BasicPage titulo="Funcionarios">
            <div className="row">
                <div className="col-md-6">
                    <SelectIDFunctionalSingleton returnType="Object" idSelector={form.FunctionalArea?.IDLn} onChange={(e) => { setForm({ ...form, FunctionalArea: e }) }} />
                </div>
                <div className="col-md-6 mt-4">
                    <strong>Jefe/Coordinador</strong><br /> {form.FunctionalArea?.IDBoss}
                </div>
                <div className="col-md-12">

                    <BasicTable iconButtons={iconButtonsItem} headButtons={buttons()} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} records={paginador} />

                    <Modal modal={modalInfo.modal} updateModal={modalInfo.setModal}>
                        <TeamGroupMembersInfo type="groupMember" groupMeber={bean} />
                    </Modal>

                    <Modal modal={modalExportList.modal} updateModal={modalExportList.setModal}>
                        {listaReport.length > 0 &&
                            <ExportXLSL customName={"Compañeros"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaReport} onExport={(name: string) => {
                                _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                            }} />
                        }
                    </Modal>

                    <Modal onSubmitLabel="Solicitar" modal={modalRequest.modal} updateModal={modalRequest.setModal} eventModal={handleModalSubmit}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea
                                    name="obs"
                                    rows={5}
                                    className={`form-control ${isValid ? "is-invalid" : ""}`}
                                    value={obs}
                                    onChange={(e) => setObs(e.target.value)}
                                />
                            </div>
                        </div>
                    </Modal>
                </div>

            </div>
        </BasicPage>

    )
}